import { render, staticRenderFns } from "./ForumCreate.vue?vue&type=template&id=f69d291c&scoped=true&"
import script from "./ForumCreate.vue?vue&type=script&lang=js&"
export * from "./ForumCreate.vue?vue&type=script&lang=js&"
import style0 from "./ForumCreate.vue?vue&type=style&index=0&id=f69d291c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69d291c",
  null
  
)

component.options.__file = "ForumCreate.vue"
export default component.exports